// extracted by mini-css-extract-plugin
export default {"mainButtonsContainer":"companies_mainButtonsContainer__YzaAA","bulkUploadModal":"companies_bulkUploadModal__07DIa","errorMessage":"companies_errorMessage__3oMg1"};